var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PWAsideBodyItem',{attrs:{"title":_vm.$t('ActionSidebarRedirectTitle')}},[_c('PWSelect',{attrs:{"placeholder":_vm.$t('messenger'),"options":[
      {
        label: 'WhatsApp',
        value: 'whatsapp',
      },
      {
        label: 'Telegram',
        value: 'telegram',
      },
      {
        label: `WhatsApp ${_vm.$t('and')} Telegram`,
        value: 'whatsapp-and-telegram',
      },
    ]},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }